// Datos de respaldo: se usan solo si Firebase no está configurado
// (ver js/firebase-config.js) o si Firestore no responde.
// Una vez activado Firebase, todo esto se carga y edita desde este panel
// (index.html — este mismo proyecto, gastro-saas-admin) y estos datos dejan de usarse.
//
// Tipos de plato:
//  - "simple": precio fijo, se agrega directo al carrito.
//  - "variantes": el cliente elige una opción de una lista (ej. tamaño de
//    pizza), cada una con su propio precio. Puede tener "addons" (extras
//    opcionales con costo adicional).
//  - "configurable": el cliente arma el plato eligiendo de varios grupos
//    de opciones (ej. armar tu hamburguesa o tu burrito). Tiene un
//    precioBase y una lista de "grupos", cada uno con tipoSeleccion "radio"
//    (elegí 1) o "checkbox" (elegí entre min y max), y sus "opciones" (cada
//    una con nombre y un precioExtra opcional que se suma al precioBase).
//
// Campos opcionales en cualquier tipo de plato (se agregan desde el panel):
//  - "stock": número de unidades disponibles, o ausente/null para "sin
//    límite". El sitio bloquea el pedido solo cuando llega a 0.
//  - "imagenUrl": foto del plato como imagen comprimida en formato data URL
//    (se genera y guarda directo desde el panel, sin depender de ningún
//    servicio externo). Si no está, la card se muestra sin imagen.
//
// Este catálogo de ejemplo mezcla a propósito varias gastronomías (pizza,
// hamburguesas, lomos, tacos/burritos, más una barra con cervezas, vinos y
// tragos) para mostrar el rango del producto — cada negocio real después
// carga solo lo suyo. Las categorías (ver CATEGORIAS más abajo) son
// editables desde Configuración → "Categorías del menú"; esta lista es
// nada más el punto de partida antes de que un negocio la personalice.

const MENU_FALLBACK: PlatoConId[] = [
  // ---------- Menú del día ----------
  {
    id: "milanesa-pollo-dia",
    nombre: "Milanesa de pollo con puré",
    descripcion: "Plato del día. Milanesa de pollo con puré de papas.",
    precio: 8000,
    categoria: "menu-del-dia",
    disponible: true,
    esDelDia: true,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "guiso-lentejas",
    nombre: "Guiso de lentejas",
    descripcion: "Plato del día. Guiso casero de lentejas con chorizo.",
    precio: 7000,
    categoria: "menu-del-dia",
    disponible: true,
    esDelDia: true,
    orden: 2,
    tipo: "simple",
  },

  // ---------- Pizzas ----------
  {
    id: "pizza-muzzarella",
    nombre: "Pizza muzzarella",
    descripcion: "Salsa de tomate, muzzarella y aceitunas.",
    categoria: "pizzas",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "variantes",
    variantes: [
      { id: "chica", nombre: "Chica", precio: 6000 },
      { id: "grande", nombre: "Grande", precio: 9500 },
      { id: "familiar", nombre: "Familiar", precio: 13000 },
    ],
  },
  {
    id: "pizza-napolitana",
    nombre: "Pizza napolitana",
    descripcion: "Muzzarella, rodajas de tomate, ajo y albahaca.",
    categoria: "pizzas",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "variantes",
    variantes: [
      { id: "chica", nombre: "Chica", precio: 6500 },
      { id: "grande", nombre: "Grande", precio: 10000 },
      { id: "familiar", nombre: "Familiar", precio: 14000 },
    ],
  },
  {
    id: "pizza-porcion-fugazzeta",
    nombre: "Porción de fugazzeta",
    descripcion: "Una porción, para comer en el momento.",
    precio: 2800,
    categoria: "pizzas",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "simple",
  },

  // ---------- Hamburguesas ----------
  {
    id: "hamburguesa-clasica",
    nombre: "Hamburguesa clásica",
    descripcion: "Carne, lechuga, tomate y mayonesa, en pan de papa.",
    precio: 7000,
    categoria: "hamburguesas",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "hamburguesa-doble-cheddar",
    nombre: "Doble cheddar y panceta",
    descripcion: "Doble carne, doble cheddar y panceta crocante.",
    precio: 8500,
    categoria: "hamburguesas",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "arma-tu-hamburguesa",
    nombre: "Armá tu hamburguesa",
    descripcion: "Elegí la base y los agregados. Hasta 3 complementos.",
    categoria: "hamburguesas",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "configurable",
    precioBase: 6500,
    grupos: [
      {
        id: "base",
        nombre: "Base (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Carne" }, { nombre: "Pollo" }, { nombre: "Vegetariana" }],
      },
      {
        id: "complementos",
        nombre: "Complementos (hasta 3)",
        tipoSeleccion: "checkbox",
        min: 0,
        max: 3,
        opciones: [
          { nombre: "Cheddar" },
          { nombre: "Panceta", precioExtra: 800 },
          { nombre: "Huevo frito" },
          { nombre: "Cebolla caramelizada" },
        ],
      },
      {
        id: "guarnicion",
        nombre: "Guarnición (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Papas fritas" }, { nombre: "Ensalada" }, { nombre: "Aros de cebolla", precioExtra: 500 }],
      },
    ],
  },

  // ---------- Lomos ----------
  {
    id: "lomito-completo",
    nombre: "Lomito completo",
    descripcion: "Con jamón, queso, lechuga, tomate y huevo.",
    precio: 8500,
    categoria: "lomos",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "lomito-arabe",
    nombre: "Lomito árabe",
    descripcion: "En pan árabe, con salsa blanca y papas pay.",
    precio: 7500,
    categoria: "lomos",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },

  // ---------- Tacos y burritos ----------
  {
    id: "tacos-carne",
    nombre: "Tacos de carne (3 unidades)",
    descripcion: "Tortillas de maíz, carne, cebolla y cilantro.",
    precio: 6000,
    categoria: "tacos-burritos",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "tacos-pollo",
    nombre: "Tacos de pollo (3 unidades)",
    descripcion: "Tortillas de maíz, pollo, cebolla y cilantro.",
    precio: 5500,
    categoria: "tacos-burritos",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "arma-tu-burrito",
    nombre: "Armá tu burrito",
    descripcion: "Elegí la proteína, los toppings y el nivel de picante.",
    categoria: "tacos-burritos",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "configurable",
    precioBase: 7000,
    grupos: [
      {
        id: "proteina",
        nombre: "Proteína (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Carne" }, { nombre: "Pollo" }, { nombre: "Vegetariano" }],
      },
      {
        id: "toppings",
        nombre: "Toppings (hasta 4)",
        tipoSeleccion: "checkbox",
        min: 0,
        max: 4,
        opciones: [
          { nombre: "Guacamole", precioExtra: 800 },
          { nombre: "Pico de gallo" },
          { nombre: "Queso" },
          { nombre: "Frijoles" },
          { nombre: "Arroz" },
        ],
      },
      {
        id: "picante",
        nombre: "Picante (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Suave" }, { nombre: "Medio" }, { nombre: "Picante" }],
      },
    ],
  },

  // ---------- Ensaladas ----------
  {
    id: "ensalada-mixta",
    nombre: "Ensalada mixta",
    descripcion: "Ensalada simple, elegí el tamaño.",
    categoria: "ensaladas",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "variantes",
    variantes: [
      { id: "individual", nombre: "Individual", precio: 1500 },
      { id: "compartir", nombre: "Para compartir", precio: 2500 },
      { id: "4p", nombre: "Para 4 personas", precio: 4000 },
    ],
  },
  {
    id: "ensalada-armala",
    nombre: "Armá tu ensalada",
    descripcion: "Elegí la base, la proteína y la vinagreta. Podés sumar hasta 5 complementos.",
    categoria: "ensaladas",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "configurable",
    precioBase: 7800,
    grupos: [
      {
        id: "base",
        nombre: "Base (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [
          { nombre: "Arroz integral" },
          { nombre: "Mix de hojas verdes" },
          { nombre: "Arroz integral y quinoa" },
        ],
      },
      {
        id: "complementos",
        nombre: "Complementos (hasta 5)",
        tipoSeleccion: "checkbox",
        min: 0,
        max: 5,
        opciones: [
          { nombre: "Palta" },
          { nombre: "Choclo" },
          { nombre: "Tomate cherry" },
          { nombre: "Queso" },
          { nombre: "Croutons" },
          { nombre: "Zanahoria" },
        ],
      },
      {
        id: "proteina",
        nombre: "Proteína (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Pollo" }, { nombre: "Huevo" }, { nombre: "Soja texturizada" }],
      },
      {
        id: "vinagreta",
        nombre: "Vinagreta (elegí 1)",
        tipoSeleccion: "radio",
        min: 1,
        max: 1,
        opciones: [{ nombre: "Mostaza" }, { nombre: "Aceto balsámico" }, { nombre: "Salsa césar" }],
      },
    ],
  },

  // ---------- Postres ----------
  {
    id: "postre-casero",
    nombre: "Postre casero",
    descripcion: "Variedades según el día.",
    precio: 2500,
    categoria: "postres",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "flan-casero",
    nombre: "Flan casero",
    descripcion: "Con dulce de leche y crema.",
    precio: 3000,
    categoria: "postres",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "helado-dos-bochas",
    nombre: "Helado (2 bochas)",
    descripcion: "Sabores del día.",
    precio: 2800,
    categoria: "postres",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "simple",
  },

  // ---------- Bebidas sin alcohol ----------
  {
    id: "gaseosa-linea-coca",
    nombre: "Gaseosa línea Coca-Cola",
    descripcion: "Coca-Cola, Sprite o Fanta, 500ml.",
    precio: 2500,
    categoria: "sin-alcohol",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "agua-mineral",
    nombre: "Agua mineral",
    descripcion: "Con o sin gas, 500ml.",
    precio: 1800,
    categoria: "sin-alcohol",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "limonada-casera",
    nombre: "Limonada casera",
    descripcion: "Con menta y jengibre.",
    precio: 3200,
    categoria: "sin-alcohol",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "simple",
  },

  // ---------- Cervezas ----------
  {
    id: "cerveza-tirada",
    nombre: "Cerveza tirada (pinta)",
    descripcion: "Rubia tirada.",
    precio: 3500,
    categoria: "cervezas",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "cerveza-artesanal-ipa",
    nombre: "Cerveza artesanal IPA",
    descripcion: "Botella 500ml.",
    precio: 4500,
    categoria: "cervezas",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "cerveza-botella",
    nombre: "Cerveza en botella",
    descripcion: "Elegí el estilo.",
    categoria: "cervezas",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "variantes",
    variantes: [
      { id: "rubia", nombre: "Rubia", precio: 3000 },
      { id: "roja", nombre: "Roja", precio: 3200 },
      { id: "negra", nombre: "Negra", precio: 3200 },
    ],
  },

  // ---------- Vinos ----------
  {
    id: "copa-vino-tinto",
    nombre: "Copa de vino tinto",
    descripcion: "Malbec de la casa.",
    precio: 3500,
    categoria: "vinos",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "copa-vino-blanco",
    nombre: "Copa de vino blanco",
    descripcion: "Chardonnay de la casa.",
    precio: 3500,
    categoria: "vinos",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "botella-vino-casa",
    nombre: "Botella de vino de la casa",
    descripcion: "Malbec, 750ml.",
    precio: 12000,
    categoria: "vinos",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "simple",
  },

  // ---------- Tragos ----------
  {
    id: "fernet-cola",
    nombre: "Fernet con coca",
    descripcion: "Trago clásico.",
    precio: 4000,
    categoria: "tragos",
    disponible: true,
    esDelDia: false,
    orden: 1,
    tipo: "simple",
  },
  {
    id: "gin-tonic",
    nombre: "Gin tonic",
    descripcion: "Con botánicos y cítricos.",
    precio: 5500,
    categoria: "tragos",
    disponible: true,
    esDelDia: false,
    orden: 2,
    tipo: "simple",
  },
  {
    id: "mojito",
    nombre: "Mojito",
    descripcion: "Ron, menta, lima y soda.",
    precio: 5000,
    categoria: "tragos",
    disponible: true,
    esDelDia: false,
    orden: 3,
    tipo: "simple",
  },
  {
    id: "aperol-spritz",
    nombre: "Aperol spritz",
    descripcion: "Aperol, espumante y soda.",
    precio: 5500,
    categoria: "tragos",
    disponible: true,
    esDelDia: false,
    orden: 4,
    tipo: "simple",
  },
];

// Lista de categorías por defecto — se usa en modo demo y como punto de
// partida la primera vez que un negocio abre Configuración → "Categorías
// del menú". Un negocio real la reemplaza por la suya (ver
// config/general.categorias en NOTAS-TECNICAS.md); esto es solo el
// fallback, no una lista fija.
const CATEGORIAS: Categoria[] = [
  { id: "menu-del-dia", nombre: "Menú del día" },
  { id: "pizzas", nombre: "Pizzas" },
  { id: "hamburguesas", nombre: "Hamburguesas" },
  { id: "lomos", nombre: "Lomos" },
  { id: "tacos-burritos", nombre: "Tacos y burritos" },
  { id: "ensaladas", nombre: "Ensaladas" },
  { id: "postres", nombre: "Postres" },
  { id: "sin-alcohol", nombre: "Bebidas sin alcohol" },
  { id: "cervezas", nombre: "Cervezas" },
  { id: "vinos", nombre: "Vinos" },
  { id: "tragos", nombre: "Tragos" },
];

// Campos de marca opcionales (no incluidos acá a propósito, para que el modo
// demo siga usando los colores por defecto del CSS y sin logo):
//  - colorPrimario, colorPrimarioOscuro, colorAcento, colorFondo: hex (#rrggbb)
//  - logoUrl: data URL base64 de un logo ya comprimido (ver js/marca.js)
const CONFIG_FALLBACK: ConfigLocal = {
  nombreLocal: "Tu Negocio",
  eslogan: "Tu eslogan acá",
  frase: "Tu frase de marca acá",
  whatsapp: "5490000000000",
  alias: "TU.ALIAS.AQUI",
  direccion: "Tu dirección acá",
  instagram: "tu_negocio",
  diasAbierto: [1, 2, 3, 4, 5, 6],
  horarios: [{ desde: "11:00", hasta: "15:30" }],
  horaDesde: "11:00",
  horaHasta: "15:30",
  envioActivo: true,
  retiroActivo: true,
  modoCarta: false,
  zonasEnvio: [],
};
